import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHourglassStart } from '@fortawesome/free-solid-svg-icons'

const OtpTimer = (props) => {
    const { text, timer, timerAction, setTimer } = props

    useEffect(() => {
        let myInterval = setInterval(() => {
            if (timer > 0) {
                setTimer(timer - 1)
            }
        }, 1000)
        return () => {
            clearInterval(myInterval)
        }
    })

    return (
        <div>
            {timer === 0
                ? <button className='btn btn-primary px-2 py-0 my-1' onClick={timerAction}>{text}{' '}</button>
                : <button className='btn btn-secondary px-2 py-0 my-1' ><FontAwesomeIcon icon={faHourglassStart} className='me-2' />{text}{' '} {timer < 10 ? `0${timer}` : timer}</button>
            }
        </div>
    )
}

OtpTimer.propTypes = {
    text: PropTypes.string,
    timer: PropTypes.number,
    setTimer: PropTypes.func,
    timerAction: PropTypes.func,
}

export default OtpTimer
